<table class="table table-responsive table-bordered form-row">
    <thead>
        <tr>
            <th></th>
            <th>Anno N</th>
            <th>Anno N - 1</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <td></td>
            <td>
                <div class="input-container">
                    <input class="form-control isAnno" type="text" id="ContributoLegge59§BilAnno2" bind="my:BilAnno2" data-path="jsonDati['dati']['my:Verbale']['my:SezioneI-Rilevazione']['my:DatiBilancio']['my:BilAnno2']">
                </div>
                
            </td>
            <td>
                <div class="input-container">
                    <input class="form-control isAnno" type="text" id="ContributoLegge59§BilAnno1" bind="my:BilAnno1" data-path="jsonDati['dati']['my:Verbale']['my:SezioneI-Rilevazione']['my:DatiBilancio']['my:BilAnno1']">
                </div>
                
            </td>
        </tr>
        <tr>
            <td class="td-title">
                a) risultato dell'esercizio
                <sup class="avvisi">1)</sup>
            </td>
            <td>
                <div class="input-group input-container">
                    <span class="input-group-addon">€</span>
                    <input class="form-control isDouble text-right" type="text" id="ContributoLegge59§RisultEsercizio" bind="my:RisultEsercizio" data-path="jsonDati['dati']['my:Verbale']['my:SezioneI-Rilevazione']['my:ContributoLegge59']['my:RisultEsercizio']">
                </div>
               
            </td>
            <td>
                <div class="input-group input-container">
                    <span class="input-group-addon">€</span>
                    <input class="form-control isDouble text-right" type="text" id="ContributoLegge59§RisultEsercizioAnno1" bind="my:RisultEsercizioAnno1" data-path="jsonDati['dati']['my:Verbale']['my:SezioneI-Rilevazione']['my:ContributoLegge59']['my:RisultEsercizioAnno1']">
                </div>
                
            </td>
        </tr>
        
    </tbody>
</table>